<template>
  <model-crud
    :model="model"
    :fields="fields"
    :include="['target']"
  />
</template>

<script>
import ModelCrud from '@/components/ModelCrud'
import Number from '@/models/Number'
import Line from '@/models/Line'

export default {
  data () {
    return {
      model: Number,
      fields: {
        phone: { label: this.$t('headers.phoneNumber'), fill: true },
        note: {
          label: this.$t('headers.note'),
          fill: true,
          multiLine: true,
          displayLength: 20
        },
        target: {
          label: this.$t('headers.target'),
          type: 'reference',
          model: Line,
          fill: true
        },
        recordingType: { label: this.$t('headers.recordingType'), type: 'enum', values: Number.enums.recordingType, fill: true },
        enabled: { label: this.$t('headers.enabled'), type: 'bool', default: true, fill: true }
      }
    }
  },
  components: {
    ModelCrud
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Numbers.vue?013e5a0b